export enum DigitalChannelType {
  INSTAGRAM = 'Instagram',
  TWITTER = 'X',
  EMAIL = 'Email',
  HISTORYEMAIL = 'HistoryEmail',
  CHAT = 'Chat',
  CHATWITHBOTRANSCRIPT = 'ChatWithBotTranscript',
  WHATSAPP = 'Whatsapp',
  FACEBOOK = 'Facebook',
  LINKEDIN = 'Linkedin',
  SMS = 'sms',
  VIDEOCALL = 'VideoCall',
}
